import * as React from 'react';
import * as Moment from 'moment-timezone';

interface ITimezoneSelectorProps {
  tz: string;
  onChange: (tz: string) => void;
}

function getNames() {
  const names = Moment.tz.names();
  const ret = [];
  for (const name of names) {
    const zone = Moment.tz.zone(name);
    if (zone && zone.population > 1000000) {
      ret.push(name);
    }
  }
  return ret;
}

const ZONE_NAMES = getNames();

export default function TimezoneSelector(props: ITimezoneSelectorProps) {
  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    props.onChange(e.target.value);
  }
  return (
    <select
      className="custom-select no-left-radius"
      title="Time zone"
      onChange={onChange}
      value={props.tz}
    >
      {ZONE_NAMES.map(name =>
        <option key={name} value={name}>
          {name === props.tz ?
            '🌐 '
            :
            null
          }
          {name}
        </option>
      )}
    </select>
  )
}


// WEBPACK FOOTER //
// ./src/Calculator/TimezoneSelector.tsx